import Icon from '../Icon';
import React from 'react';
import Tooltip from '../Tooltip';
const InfoTooltip = ({ content, size = 'm', color }) => {
    return (React.createElement(Tooltip, { content: content },
        React.createElement(Icon, { name: "tooltip", size: size, color: color })));
};
export default InfoTooltip;
